import * as API from './export'

export default {
    // 导出报表
    exportExcel: (url,method,params) => {
        return API.EXPORT(url,method, params);
    }
}


// WEBPACK FOOTER //
// ./src/libs/api_dispatch.js